// extracted by mini-css-extract-plugin
module.exports = {"container":"Article_container__1hwri","title":"Article_title__225Xw","date":"Article_date__2pnGT","content":"Article_content__T2l7V"};